import React from 'react';
import ButtonGroup from '@components/button-group';
import Column from '@components/column';
import ImageBlock from '@components/image-block';
import { useUID } from 'react-uid';
import RichText from '@components/rich-text';
import Button from '@components/button';
import StampedEmbed from '@components/reviews/stamped-embed';
import VideoBlock from '@components/video';
import EmbeddedHTML from '@components/blocks/embedded-html';
import { linkProps } from '@src/utils/general';
import { calculateColumnWidth } from './helpers';
import Pdf from '@components/pdf';

const blockMap = {
  customImage: ImageBlock,
  richTextObject: RichText,
  ctaListObject: ButtonGroup,
  cta: Button,
  reviewsWidget: StampedEmbed,
  video: VideoBlock,
  embeddedHTML: EmbeddedHTML,
  pdf: Pdf
};

const getBlockComponent = (block, columnWidth) => {
  const { _type, _key } = block;
  const Component = blockMap[_type];

  if (typeof blockMap[_type] === "undefined") {
    return <p>Not supported: {_type}</p>
  }

  let props
  switch (_type) {
    case 'richTextObject':
      props = { text: block.content}
      break;
    case 'ctaListObject':
      props = { list: block.ctaList }
      break;
    case 'customImage':
      props = { image: { ...block }, width: calculateColumnWidth(columnWidth), wrapperClassName: `${block?.heightMobile || ''} ${block.heightDesktop ? `md:${block.heightDesktop}` : ''}`, ...linkProps(block.internalLink, block.externalUrl) }
      break;
    case 'reviewsWidget':
      props = { ...block, productEntries: [block.product], className: '-mt-6'}
      break;
    case 'video':
      props = { ...block, maxWidth: calculateColumnWidth(columnWidth) }
      break;
    default:
      props = block
  }

  return <Component {...props} key={_key} />
};

const renderBlocks = (blocks, columnWidth) => blocks?.map((block) => getBlockComponent(block, columnWidth)).filter(Boolean);

const renderColumn = ({ topContent, bottomContent, columnSettings }) => {
  return(
    <Column
      {...columnSettings}
      verticalSpacing="justify-start"
      key={useUID()}
      className="p-[5px] md:p-0"
    >
      {renderBlocks(topContent, columnSettings?.columnWidth)}
      {bottomContent && bottomContent?.length > 0 && 
        <div className='h-full'></div>}
      {renderBlocks(bottomContent, columnSettings?.columnWidth)}
    </Column>
  )
};

const SectionBuilder = ({ columns }) => columns?.map(renderColumn).filter(Boolean);

export default SectionBuilder;
